import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { formValueSelector, FormSection } from "redux-form";
import { DashedSeparator } from "MODULES/shared/components";
import { ShipToFields } from "MODULES/Orders/shared/ShippingFields";
import { ShippingMethod } from "MODULES/shared/components/Forms/FormSections";
import { Col } from "react-bootstrap";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { DO_NOT_SHIP } from "MODULES/PurchaseOrders/constants";
import { findMatch } from "LIB/arrays";

function ShippingFields({
  children,
  doNotShip = false,
  disabled = false,
  required = true,
  ship_to_fields_required: shipToFieldsRequired = true,
  renderCarrier = true,
  setTenantAccount = false,
  enableReturnToType = true,
  rmaRequestForm = false,
  ...props
}) {
  return (
    <div>
      <FormRow>
        <Col md={12}>
          <ShipToFields
            {...props}
            required={shipToFieldsRequired}
            disabled={disabled}
            enableReturnToType={enableReturnToType}
            rmaRequestForm={rmaRequestForm}
          />
        </Col>
      </FormRow>
      {children}
      <DashedSeparator />
      {renderCarrier && (
        <FormSection name={props.shippingMethod}>
          <ShippingMethod
            setTenantAccount={setTenantAccount}
            required={required}
            disabled={disabled}
            doNotShip={doNotShip}
          />
        </FormSection>
      )}
    </div>
  );
}

ShippingFields.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  doNotShip: PropTypes.bool,
  renderCarrier: PropTypes.bool,
  required: PropTypes.bool,
  ship_to_fields_required: PropTypes.bool,
  setTenantAccount: PropTypes.bool,
  disabled: PropTypes.bool,
  shippingMethod: PropTypes.string
};

const selector = (form, ...other) => formValueSelector(form)(...other);

export default connect((state, ownProps) => ({
  doNotShip:
    selector(
      ownProps.formName,
      state,
      findMatch(ownProps.shippingFields, "type")
    ) === DO_NOT_SHIP,
  country: selector(
    ownProps.formName,
    state,
    `${ownProps.shippingAddressField}.country`
  ),
  city: selector(
    ownProps.formName,
    state,
    `${ownProps.shippingAddressField}.city`
  ),
  province: selector(
    ownProps.formName,
    state,
    `${ownProps.shippingAddressField}.state`
  )
}))(ShippingFields);



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingFields/ShippingFields.jsx